export default {
  "OptionTextContainer": "_OptionTextContainer_vt4gp_1",
  "OptionText": "_OptionText_vt4gp_1",
  "OptionTextLight": "_OptionTextLight_vt4gp_9"
};import "ni:sha-256;1ZcGnn37m4umAAEFiRjUg5k-ZLgPeVEkQtnD-_UogfU";